import {createSlice, PayloadAction, SliceCaseReducers} from '@reduxjs/toolkit';
import {AppActions} from '../../actions';
import {
  Certificate,
  CertificateInfo,
  Seller,
  Department,
} from '../../../shared/models/api/eCertificatesResponsePayload';

export interface ECertificatesState {
  active: Certificate[] | null;
  history: Certificate[] | null;
  certificateInfo: CertificateInfo | null;
  sellers: Seller[] | null;
  department: Department | null;
  downloading: boolean;
}

const initialState: ECertificatesState = {
  active: [],
  history: [],
  certificateInfo: null,
  sellers: [],
  department: null,
  downloading: false,
};

export const eCertificatesSlice = createSlice<ECertificatesState, SliceCaseReducers<ECertificatesState>>({
  name: '@@eskso/certificates',
  initialState,
  reducers: {
    setActiveCertificates: (state, action: PayloadAction<Certificate[]>) => {
      state.active = action.payload;
    },
    setCertificatesHistory: (state, action: PayloadAction<Certificate[]>) => {
      state.history = action.payload;
    },
    setCertificateInfo: (state, action: PayloadAction<CertificateInfo>) => {
      state.certificateInfo = action.payload;
    },
    setSellers: (state, action: PayloadAction<Seller[]>) => {
      state.sellers = action.payload;
    },
    setDepartment: (state, action: PayloadAction<Department>) => {
      state.department = action.payload;
    },
    setDownloading: (state, action: PayloadAction<boolean>) => {
      state.downloading = action.payload;
    },
  },
  extraReducers: {
    [AppActions.Reset]: () => {
      return initialState;
    },
  },
});

export const eCertificates = eCertificatesSlice.reducer;
